import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: 'Notti intere a cercare schemi KNX su Google o manuali obsoleti.',
  good: 'Lezioni, schemi e verifiche pronte sul tuo tablet in 2 clic.'
}, {
  bad: 'Stress per non sapere come spiegare Matter, Thread o le nuove norme CEI 64-8.',
  good: 'Sicurezza totale e autorità tecnica entrando in aula o in cantiere.'
}, {
  bad: 'Spiegazioni confuse su protocolli che i tuoi allievi non riescono a seguire.',
  good: 'Supporti visuali e schemi professionali che incantano gli studenti.'
}, {
  bad: 'Frustrazione per un programma didattico disorganizzato e senza progressione.',
  good: 'Cronogramma da 200 ore già pronto, dalla teoria alla pratica reale.'
}];
export function ComparisonTable() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-59">
      <div className="max-w-5xl mx-auto" data-id="element-60">
        <p className="text-center text-base sm:text-lg text-brand-cream font-bold mb-6" data-id="element-61">
          Ricomincia ad amare il lunedì mattina.
        </p>
        <div className="grid grid-cols-1 gap-4" data-id="element-62">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#1a0f0a] border border-red-900/50 rounded-2xl p-6 sm:p-8" data-id="element-63">
            <h3 className="text-xl sm:text-2xl font-black text-red-500 mb-6 text-center uppercase tracking-wide leading-tight" data-id="element-64">
              ❌ Senza Sistema Domotica Pro
            </h3>
            <p className="text-center text-xs text-gray-500 uppercase font-bold tracking-wider mb-5" data-id="element-65">
              Cosa ti costa oggi
            </p>
            <div className="space-y-4" data-id="element-66">
              {comparisons.map((item, i) => <div key={i} className="flex gap-3 items-start" data-id="element-67">
                  <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-68">
                    <XIcon className="w-5 h-5 text-red-500" data-id="element-69" />
                  </div>
                  <p className="text-gray-300 font-medium text-sm sm:text-base" data-id="element-70">
                    {item.bad}
                  </p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-[#1a140a] to-[#0f0a05] border border-brand-orange/50 rounded-2xl p-6 sm:p-8 shadow-[0_0_30px_rgba(249,115,22,0.15)] relative overflow-hidden" data-id="element-71">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-orange to-brand-gold" data-id="element-72" />
            <h3 className="text-xl sm:text-2xl font-black text-brand-gold mb-6 text-center uppercase tracking-wide leading-tight" data-id="element-73">
              ✅ Con Sistema Domotica Pro
            </h3>
            <p className="text-center text-xs text-brand-gold/70 uppercase font-bold tracking-wider mb-5" data-id="element-74">
              La tua vita domani
            </p>
            <div className="space-y-4" data-id="element-75">
              {comparisons.map((item, i) => <div key={i} className="flex gap-3 items-start" data-id="element-76">
                  <div className="mt-1 bg-green-500/20 p-1 rounded-full shrink-0" data-id="element-77">
                    <CheckIcon className="w-5 h-5 text-green-500" data-id="element-78" />
                  </div>
                  <p className="text-brand-cream font-bold text-sm sm:text-base" data-id="element-79">
                    {item.good}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}